import { Button } from "@svea/design-system-components-react";
import { FileTrigger, type FileTriggerProps } from "react-aria-components";
import { FileBox } from "./file-box";

export type FormFile = {
	name: string;
	/**@field s3Key will be missing if this file is not uploaded to the server yet. */
	s3Key?: string;
	/**@field originalFile is only set if we have access to this file. If the file is previously uploaded to the server this will be missing */
	originalFile?: File;
};

type FileInputProps = Omit<FileTriggerProps, "onSelect"> & {
	onSelect: (e: FormFile[]) => void;
	value: FormFile[];
	exchangeForBlob?: (file: FormFile) => Promise<Blob>;
	onFileDeleted?: () => void;
	acceptedFileTypes?: string[];
} & React.RefAttributes<HTMLInputElement>;

export const FileInput = ({
	value,
	onSelect,
	exchangeForBlob,
	onFileDeleted,
	acceptedFileTypes = ["application/pdf"],
	...props
}: FileInputProps) => {
	return (
		<div className="flex flex-row items-center gap-4">
			{value.length < 1 && (
				<FileTrigger
					{...props}
					acceptedFileTypes={acceptedFileTypes}
					onSelect={(e) => {
						const files = e ? Array.from(e) : [];
						const filenames = files.map((file) => ({
							name: file.name,
							originalFile: file,
							mimeType: file.type,
						}));
						onSelect(filenames);
					}}
				>
					<Button variant="secondary">Välj fil</Button>
				</FileTrigger>
			)}
			<div>
				{value.map((f) => (
					<FileBox
						key={f.name}
						file={f}
						onDelete={onFileDeleted}
						fetcher={exchangeForBlob ? () => exchangeForBlob(f) : undefined}
					/>
				))}
			</div>
		</div>
	);
};
